import { createFileRoute } from '@tanstack/react-router';
// relative imports
import Loader from '../../../../../../../../../components/shared/custom-components/Loader';
import WalletAddressesContainer from '../../../../../../../../../components/source-management/wallets/wallet-page/wallet-addresses/WalletAddressesContainer';

export const Route = createFileRoute(
  '/_authenticated/client/$accountId/_clientWrapper/(sources)/wallets/$walletId/_wallet/addresses',
)({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: WalletAddressesContainer,
});
